module.exports = __webpack_public_path__ + "static/img/3.4a1aaf8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/3.png
// module id = zUQT
// module chunks = 0